import Skillcard from "../skillcard/Skillcard";
import { SkillData } from "../../parseJson";
import "./Skills.css";

function Skills() {
  return (
    <div className="main-section container-fluid resume" id="skills">
      <div className="container">
        <div className="skill-sec">
          <div className="row">
            <div className="col-12">
              <div className="heading-container">
                <p className="heading-subtitle">{SkillData.subtitle}</p>
                <h2 className="heading-title">{SkillData.title}</h2>
              </div>
            </div>
          </div>

          {SkillData.skillcards.map((skillcard, index) => {
            return (
              <div className="row" key={index}>
                <div className="sec-single-item col-12">
                  <Skillcard data={skillcard} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Skills;
